export default "__VITE_ASSET__DUgo2JtF__"